(function () {

    var ua = navigator.userAgent,
        isIOS = /iphone|ipad|ipod/i.test(ua),
        isAndroid = /android/i.test(ua),
        isChrome = /chrome|crios/i.test(ua),
        isWeixin = /micromessenger/i.test(ua);

    var appPopup = {
        hasAppCookieName: "has_hjclass_app",

        attachAppPopup: function () {
            var alink = $("#video a.video_content")[0], me = this;
            if (!alink) return;
            me.__oldOnclick = alink.onclick;
            alink.onclick = function () {
                if (me.hasAppInstalled()) {
                    me.callApp();
                } else {
                    me.showAppPopup();
                }
                return false;
            };
        },

        showAppPopup: function () {
            var me = this;
            //不提示
            if (me.hasAppInstalled()) {
                me.callApp();
                return;
            }

            if ($("#div_app_start").length > 0) {
                //安装应用
                $("#btnInstallApp").on("click", function () {
                    if (isWeixin) {
                        $("#btnInstallApp").attr("href", 'http://m.hujiang.com/app/hjclass/');
                    } else {
                        $("#btnInstallApp").attr("href", me.getAppInstallURL());
                    }

                    $("#btnInstallApp").on("click", function () {
                        me.hideAppPopup();
                    });
                });

                //已安装过，直接调用原生应用
                $("#btnHasApp").on("click", function () {
                    if ($("#cbAppNoTip:checked").val() == "1") {
                        me.setAppInstalled();
                    }

                    me.hideAppPopup();
                    me.callApp();
                });

                $("#div_app_start").show();
            }
        },

        hideAppPopup: function () {
            $("#div_app_start").hide();
        },

        callApp: function () {
            var appURI = this.getAppURI();
            location.href = appURI;
        },

        hasAppInstalled: function () {
            return !!this.getCookie(this.hasAppCookieName);
        },

        setAppInstalled: function () {
            this.addCookie(this.hasAppCookieName, 1, 7 * 24);
        },

        getAppURI: function () {
            var appProtocol = "hujiangclass3://",
                userid = parseInt($("#hidden_uid").val()),
                classid = parseInt($("#hidden_cid").val()),
                lessonid = parseInt($("#hidden_lid").val());
            return appProtocol + "hjclass.hujiang.com?userid=" + userid + "&classid=" + classid + "&lessonid=" + lessonid;
        },

        getAppInstallURL: function () {
            if (isAndroid) {
                return "http://app.m.hjfile.cn/android/hujiangclass3_h5.apk";
            } else if (isIOS) {
                if (isChrome) {
                    return "itms-apps://phobos.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=738227542";
                }
                return "http://lnk8.cn/I10YJ9";
            }
            return "";
        },

        getCookie: function (objName) {
            var arrStr = document.cookie.split("; ");
            for (var i = 0; i < arrStr.length; i++) {
                var temp = arrStr[i].split("=");
                if (temp[0] == objName) return unescape(temp[1]);
            }
            return null;
        },

        addCookie: function (objName, objValue, objHours, domain) {
            var str = objName + "=" + escape(objValue);
            if (objHours > 0) {
                var date = new Date();
                var ms = objHours * 3600 * 1000 * 100;
                date.setTime(date.getTime() + ms);
                str += ";expires=" + date.toGMTString();
                if (domain != null && domain.length > 0) {
                    str += ";domain=" + domain;
                }
            }
            document.cookie = str + ";path=/";
        },

        getFlashVersion: function () {
            var ver;
            if (navigator.plugins && navigator.mimeTypes.length) {
                ver = (navigator.plugins['Shockwave Flash'] || 0).description;
            } else if (window['ActiveXObject']) {
                try {
                    ver = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')['GetVariable']('$version');
                } catch (e) { }
            }
            if (ver) return ver.match(/\d+/g).splice(0, 3);
            return null;
        }
    };

    if (isIOS || isAndroid) {
        appPopup.attachAppPopup();
    }
    window.appPopup = appPopup;

})();

$(function () {
    $("#appCloseBtn").click(function () {
        $("#downloadApp").hide();
        HJMCommon.setLocalStorage('tip_downloadApp', 1, 365);
    });
    if (HJMCommon.getLocalStorage('tip_downloadApp')) {
        $("#downloadApp").remove();
    }
    //下载应用
    var ua = navigator.userAgent,
        isWeixin = /micromessenger/i.test(ua),
        isIos = /iphone|ipad|ipod/i.test(ua),
        isAndroid = /android/i.test(ua),
        device_type = isIos ? 'ios' : (isAndroid ? 'android' : '');

   //  if (isWeixin) {
   //      $('#link_download').attr('href', 'http://m.hujiang.com/app/hjclass/');
   //  }
   //  else {
   //      $('#link_download').attr('href', appPopup.getAppInstallURL())
			// .attr('target', '_blank');
   //  }
   //  if (!device_type) {
   //      $('#downloadApp').hide();
   //  }
    
    $('#link_download').on('click', function (e) {
       SendEvent(25, 199, '{"dev_type":"{dev_type}"}'.replace('{dev_type}', device_type));
    });
    
});





//////////////////
// WEBPACK FOOTER
// ./js/callapp.js
// module id = 39
// module chunks = 0